type PopoverHeaderAction = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
};

type PopoverHeaderProps = {
  label: string;
  /** Optional right-aligned action link (e.g. "Clear all" / "Reset"). */
  action?: PopoverHeaderAction;
};

/**
 * Shared header row for toolbar popovers: an uppercase label and an optional
 * right-aligned action link. The link is muted and inert when disabled.
 */
export function PopoverHeader({ label, action }: PopoverHeaderProps) {
  return (
    <div className="mb-2 flex items-center justify-between border-b border-gray-300 pb-2">
      <span className="text-xs font-semibold uppercase tracking-wide text-popover-foreground/60">
        {label}
      </span>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          disabled={action.disabled}
          className={
            action.disabled
              ? 'cursor-default text-xs text-gray-400'
              : 'cursor-pointer text-xs text-primary-600 hover:text-primary-700'
          }
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
